import { render, staticRenderFns } from "./FormCommentContent.vue?vue&type=template&id=3d301350&scoped=true&"
import script from "./FormCommentContent.vue?vue&type=script&lang=js&"
export * from "./FormCommentContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d301350",
  null
  
)

export default component.exports